import { memo } from 'react';

import { ClockIcon } from 'lucide-react';
import { Trans } from 'react-i18next';

type Props = { minutes: number };

/**
 * Renders a reminder message with inactivity duration
 */
export const Reminder = memo(({ minutes }: Props) => {
  return (
    <div className="my-4 flex items-center justify-center gap-1 px-4 py-2">
      <ClockIcon size={14} className="text-muted-foreground" />
      <span className="text-sm leading-5 font-normal text-muted-foreground">
        <Trans i18nKey="ai_agents.reminder.human_chat" values={{ 0: minutes }} />
      </span>
    </div>
  );
});

Reminder.displayName = 'Reminder';
